// extracted by mini-css-extract-plugin
export var productImage = "_zq-0";